export default __webpack_public_path__ + "static/1-a164b67041db149e68986a274784bd0f.jpg";